// eslint-disable
// this is an auto generated file. This will be overwritten

export const onCreateBet = `subscription OnCreateBet {
  onCreateBet {
    id
    betPosition
    betType
    betValue
    chat_id
    created_at
    event_id
    handicap
    odds
    positionName
    ss
    status_id
    time_str
    resultValue
    eventName
  }
}
`;
export const onUpdateBet = `subscription OnUpdateBet {
  onUpdateBet {
    id
    betPosition
    betType
    betValue
    chat_id
    created_at
    event_id
    handicap
    odds
    positionName
    ss
    status_id
    time_str
    resultValue
    eventName
  }
}
`;
export const onDeleteBet = `subscription OnDeleteBet {
  onDeleteBet {
    id
    betPosition
    betType
    betValue
    chat_id
    created_at
    event_id
    handicap
    odds
    positionName
    ss
    status_id
    time_str
    resultValue
    eventName
  }
}
`;
